<nz-select class="persona-drop-down"
  #select
  nzNotFoundContent=""
  nzPlaceHolder="Everyone"
  [ngModel]="selectedPersonaUI$ | async"
  [compareWith]="comparator"
  [nzShowArrow]="!(selectedPersonaUI$ | async)"
  [nzDropdownStyle]="{ display: 'none' }"
  [nzCustomTemplate]="selectedTpl"
  (click)="onSelectClick(select)"
>
  <nz-option [nzValue]="selectedPersonaUI$ | async" [nzLabel]="(selectedPersonaUI$ | async)?.title"></nz-option>
</nz-select>
<ng-template #selectedTpl let-selected>
  <nz-avatar
    class="select-image"
    nzSize="small"
    nzShape="square"
    style="background: none; color: #0b0b0b"
    [nzSrc]="isTypePersona(selected.nzValue?.type) ? selected.nzValue?.imgSrc : ''"
    [nzIcon]="isTypePersona(selected.nzValue?.type) ? selected.nzValue?.icon: 'ellipsis'"
  ></nz-avatar>
</ng-template>
<nz-modal
  nzWrapClassName="full-screen-modal"
  [nzTitle]="modalTitle"
  [nzOkText]="null"
  [nzOkDisabled]="!(hasToSelectPersona$ | async)"
  [nzWidth]="'100%'"
  [(nzVisible)]="isModalVisible"
  (nzOnCancel)="onCancel()"
  (nzOnOk)="onConfirm()"
>
  <ng-container *nzModalContent>
    <div class="persona-list-box">
      <app-persona-list (ngModelChange)="onSelect($event)"></app-persona-list>
    </div>
  </ng-container> 
</nz-modal>
